import React from 'react';
import heroImage from "../assets/images/bakeonator_hero_section_1920x1080.png";

function HeroSection() {
    return (

        <header className="hero bg-light py-5">
            <div className="container text-center py-5"> {/* Ensuring the container centers all its children */}
                {/* Directly place the image without an unnecessary div unless needed for styling */}
                <h1 className="display-3">Experience Next-Level Game Development with</h1>
                <img src={heroImage} alt="Feature" className="mb-4" style={{
                    height: '720px',
                    width: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }}/>


                <p className="lead">Discover the power of Bakeonator, the cloud-based SaaS platform that revolutionizes Unity lightmap baking. With just a few clicks, transform your game visuals through our automated, fast, and quality-driven process. Experience unparalleled efficiency and elevate your game environments to new heights, all without the need for complex setups or expensive hardware. Bakeonator is your key to unlocking breathtaking visuals with ease, ensuring your projects not only meet but exceed industry standards. Get started today and bring your Unity projects to life like never before.</p>
                <div className="mt-4">
                    <a href="#features" className="btn btn-primary btn-lg me-3">Discover More</a>
                    <a href="/signup" className="btn btn-secondary btn-lg">Get Started Free</a>
                </div>
            </div>
        </header>
    )

}

export default HeroSection;
